export const FETCH_BILLING_PLANS = 'BILLING/FETCH_BILLING_PLANS';
export const FETCH_BILLING_PLANS_ERROR = 'BILLING/FETCH_BILLING_PLANS_ERROR';
export const CLEAR_FETCH_BILLING_PLANS = 'BILLING/CLEAR_FETCH_BILLING_PLANS';

export const FETCH_STRIPE_SETUP_INTENT = 'BILLING/billing/FETCH_STRIPE_SETUP_INTENT';
export const FETCH_STRIPE_SETUP_INTENT_ERROR = 'BILLING/billing/FETCH_STRIPE_SETUP_INTENT_ERROR';
export const CLEAR_STRIPE_SETUP_INTENT = 'BILLING/billing/CLEAR_STRIPE_SETUP_INTENT';

export const UPDATE_BILLING_PLAN = 'BILLING/UPDATE_BILLING_PLAN';
export const UPDATE_BILLING_PLAN_ERROR = 'BILLING/UPDATE_BILLING_PLAN_ERROR';
export const CLEAR_UPDATE_BILLING_PLAN = 'BILLING/CLEAR_UPDATE_BILLING_PLAN';

export const UPDATE_BILLING_PLAN_PAYPAL = 'BILLING/UPDATE_BILLING_PLAN_PAYPAL';
export const UPDATE_BILLING_PLAN_PAYPAL_ERROR = 'BILLING/UPDATE_BILLING_PLAN_PAYPAL_ERROR';
export const CLEAR_UPDATE_BILLING_PLAN_PAYPAL = 'BILLING/CLEAR_UPDATE_BILLING_PLAN_PAYPAL';

export const UPDATE_BILLING_PLAN_CRYPTOCOM = 'BILLING/UPDATE_BILLING_PLAN_CRYPTOCOM';
export const UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR = 'BILLING/UPDATE_BILLING_PLAN_CRYPTOCOM_ERROR';
export const CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM = 'BILLING/CLEAR_UPDATE_BILLING_PLAN_CRYPTOCOM';

export const CANCEL_SUBSCRIPTION = 'BILLING/CANCEL_SUBSCRIPTION';
export const CANCEL_SUBSCRIPTION_ERROR = 'BILLING/CANCEL_SUBSCRIPTION_ERROR';
export const CLEAR_CANCEL_SUBSCRIPTION = 'BILLING/CLEAR_CANCEL_SUBSCRIPTION';

export const RENEW_SUBSCRIPTION = 'BILLING/RENEW_SUBSCRIPTION';
export const RENEW_SUBSCRIPTION_ERROR = 'BILLING/RENEW_SUBSCRIPTION_ERROR';
export const CLEAR_RENEW_SUBSCRIPTION = 'BILLING/CLEAR_RENEW_SUBSCRIPTION';

export const FETCH_CREDIT_CARD_INFO = 'BILLING/FETCH_CREDIT_CARD_INFO';
export const FETCH_CREDIT_CARD_INFO_ERROR = 'BILLING/FETCH_CREDIT_CARD_INFO_ERROR';
export const CLEAR_FETCH_CREDIT_CARD_INFO = 'BILLING/CLEAR_FETCH_CREDIT_CARD_INFO';

export const UPDATE_CREDIT_CARD = 'BILLING/UPDATE_CREDIT_CARD';
export const UPDATE_CREDIT_CARD_ERROR = 'BILLING/UPDATE_CREDIT_CARD_ERROR';
export const CLEAR_UPDATE_CREDIT_CARD = 'BILLING/CLEAR_UPDATE_CREDIT_CARD';

export const VALIDATE_STRIPE_COUPON_SUCCES = 'BILLING/VALIDATE_STRIPE_COUPON_SUCCES';
export const VALIDATE_STRIPE_COUPON_ERROR = 'BILLING/VALIDATE_STRIPE_COUPON_ERROR';
export const CLEAR_VALIDATE_STRIPE_COUPON = 'BILLING/CLEAR_VALIDATE_STRIPE_COUPON';

export const SET_BILLING_PLAN_SELECTOR_MODE = 'BILLING/SET_BILLING_PLAN_SELECTOR_MODE';

export const FETCH_BILLING_INVOICES = 'BILLING/FETCH_BILLING_INVOICES';
export const FETCH_BILLING_INVOICES_ERROR = 'BILLING/FETCH_BILLING_INVOICES_ERROR';
export const CLEAR_FETCH_BILLING_INVOICES = 'BILLING/CLEAR_FETCH_BILLING_INVOICES';

export const FETCH_SINGLE_INVOICE_PDF = 'BILLING/FETCH_SINGLE_INVOICE_PDF';
export const FETCH_SINGLE_INVOICE_PDF_ERROR = 'BILLING/FETCH_SINGLE_INVOICE_PDF_ERROR';
export const CLEAR_FETCH_SINGLE_INVOICE_PDF = 'BILLING/CLEAR_FETCH_SINGLE_INVOICE_PDF';

export const FETCH_BILLING_INFO = 'BILLING/FETCH_BILLING_INFO';
export const FETCH_BILLING_INFO_ERROR = 'BILLING/FETCH_BILLING_INFO_ERROR';
export const CLEAR_FETCH_BILLING_INFO = 'BILLING/CLEAR_FETCH_BILLING_INFO';

export const PATCH_BILLING_INFO_SUCCESS = 'BILLING/PATCH_BILLING_INFO_SUCCESS';
export const PATCH_BILLING_INFO_ERROR = 'BILLING/PATCH_BILLING_INFO_ERROR';
export const CLEAR_PATCH_BILLING_INFO = 'BILLING/CLEAR_PATCH_BILLING_INFO';

export const DELETE_PAYMENT_PROVIDER_SUCCESS = 'BILLING/DELETE_PAYMENT_PROVIDER_SUCCESS';
export const DELETE_PAYMENT_PROVIDER_ERROR = 'BILLING/DELETE_PAYMENT_PROVIDER_ERROR';
export const CLEAR_DELETE_PAYMENT_PROVIDER = 'BILLING/CLEAR_DELETE_PAYMENT_PROVIDER';

export const PATCH_PAYMENT_PROVIDER_SUCCESS = 'BILLING/PATCH_PAYMENT_PROVIDER_SUCCESS';
export const PATCH_PAYMENT_PROVIDER_ERROR = 'BILLING/PATCH_PAYMENT_PROVIDER_ERROR';
export const CLEAR_PATCH_PAYMENT_PROVIDER = 'BILLING/CLEAR_PATCH_PAYMENT_PROVIDER';

export const FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK = 'BILLING/FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK';
export const FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR = 'BILLING/FETCH_PAYMENT_PROVIDER_ONBOARDING_LINK_ERROR';
export const CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK = 'BILLING/CLEAR_PAYMENT_PROVIDER_ONBOARDING_LINK';
